module.exports = __webpack_public_path__ + "static/media/species-identification.0a166aba.png";